<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">{{ routeName }}</a>
      <button
        class="navbar-toggler navbar-burger"
        type="button"
        @click="toggleSidebar"
        :aria-expanded="$sidebar.showSidebar"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <div class="collapse navbar-collapse navbar-notifications">
        <ul class="navbar-nav ml-auto">
          <div v-if="notifications && notifications.length > 0" class="nav-item__circle"></div>
          <drop-down
            class="nav-item custom-nav"
            title="Уведомления"
            title-classes="nav-link"
            icon="ti-bell"
            @click.native="onOpenNotifications"
          >
            <template v-if="notifications && notifications.length > 0">
              <div
                v-for="item in notifications" 
                :key="item.id" 
                class="dropdown-item-container"
              >
                <a class="dropdown-item" href="" @click.prevent>
                  {{ item.title }}
                </a>
                <span>{{ formatDateTime(item.created_at) }}</span>
              </div>
            </template>
            <div v-else class="dropdown-item-container">
              <a class="dropdown-item" href="" @click.prevent>
                Новых уведомлений нет
              </a>
            </div>
            

            <!-- <a class="dropdown-item" href="#">Уведомление 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a> -->
          </drop-down>
          <li class="nav-item">
            <a href="#" class="nav-link" style="padding: 3px 0px 3px 20px;">
              <div class="container-img">
                <img v-if="user.avatar" :src="user.avatar">
                <img v-else src="@/assets/img/no-foto.png"/>
              </div>
            </a>
          </li>
          <li class="custom-ul">
            <drop-down
              class="nav-item small-dropdown"
              :title="user.name"
              title-classes="nav-link"
            >
              <a class="dropdown-item" href="" @click.prevent="openProfile()">Профиль</a>
              <a class="dropdown-item" href="" @click.prevent="exit()">Выйти</a>
            </drop-down>
          </li>
          <!-- <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="ti-settings"></i>
              <p>Settings</p>
            </a>
          </li> -->
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import Vue from 'vue'
import VueCookies from "vue-cookies-reactive";
import GlobalRequest from "@/plugins/globalRequest"

Vue.use(VueCookies)

export default {
  components: {VueCookies, GlobalRequest},

  computed: {
    routeName() {
      // const { name } = this.$route.meta.title;
      let title = this.$route.meta.title
      return this.capitalizeFirstLetter(title);
    },
  },

  data() {
    return {
      activeNotifications: false,
      user: {},
      notifications: [],

      readTimer: null,
      readSentIds: {}
    };
  },

  mounted() {
    this.getNotifications()
    this.getUser()
  },

  beforeDestroy() {
    if (this.readTimer) clearTimeout(this.readTimer);
  },

  methods: {
    exit() {
      document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      document.cookie = 'refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';

      localStorage.removeItem('appointment_user');
      localStorage.removeItem('current_user');
      localStorage.removeItem('head');
      localStorage.removeItem('role');
      localStorage.removeItem('auth');
      localStorage.removeItem('tableFilterSkill_' + this.user.id);
      localStorage.removeItem('tableFields_' + this.user.id);
      localStorage.removeItem('tableFilterStatus_' + this.user.id);
      localStorage.removeItem("selected_user");
      localStorage.removeItem("category_breadcrumbs");
      localStorage.removeItem("after_login_redirect");

      this.$router.replace({ name: "authentication" });
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },

    async getUser() {
      const userId = localStorage.getItem("current_user");

      if (!userId) {
        console.warn("current_user не найден в localStorage");
        this.user = null;
        return;
      }

      try {
        const res = await GlobalRequest.request(`/user/${userId}`, "GET");

        if (!res || !res.data) {
          console.warn("Некорректный ответ при получении пользователя:", res);
          this.user = null;
          return;
        }

        this.user = res.data;
      } catch (err) {
        console.error("Ошибка загрузки текущего пользователя:", err);
        this.user = null;
      }
    },

    async getNotifications() {
      const resNotifications = await GlobalRequest.request("/notifications", "GET");
      if(resNotifications && resNotifications.data) {
        this.notifications = resNotifications.data;
        console.log(resNotifications)

        // let body = {
        //   id: resNotifications.data[0].id
        // }
        // const resReadNotification = await GlobalRequest.request("/notifications/read", "POST", body);
        // if(resReadNotification) {
        //   console.log(resReadNotification)
        // }

      }
    },

    openProfile() {
      if (!this.user || !this.user.id) return;

      this.$router.push({
        name: 'profile'
      }).catch(() => {});
    },

    formatDateTime(value) {
      if (!value) return '';

      const [date, time] = value.split(' ');
      const [year, month, day] = date.split('-');
      const [hours, minutes] = time.split(':');

      return `${day}.${month}.${year} ${hours}:${minutes}`;
    },

    onOpenNotifications() {
      // перезапуск
      if (this.readTimer) clearTimeout(this.readTimer);

      this.readTimer = setTimeout(() => {
        this.markVisibleNotificationsAsRead();
      }, 2000);
    },

    async markVisibleNotificationsAsRead() {
      if (!this.notifications || !this.notifications.length) return;

      for (const n of this.notifications) {
        const id = n && n.id;
        if (!id) continue;
        if (this.readSentIds[id]) continue;

        try {
          await GlobalRequest.request("/notifications/read", "POST", { id });
          this.readSentIds[id] = true;
        } catch (e) {
          console.error("read notification error", id, e);
        }
      }

    }

  },
};
</script>
<style>
  .navbar-notifications .dropdown-menu {
    max-height: 50vh;
    overflow: auto;
  }
  .navbar-notifications .dropdown-menu::-webkit-scrollbar {
    border-radius: 100px;
    background: #e3e3e3;
    height: 5px;
    width: 5px;
    cursor: pointer;
  }
  .navbar-notifications .dropdown-menu::-webkit-scrollbar-thumb {
    background: #cacaca;
    border-radius: 100px;
    cursor: pointer;
  }
</style>
